import React from 'react'
import {
  closestCenter,
  DndContext,
  DragEndEvent,
  DragStartEvent,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors
} from '@dnd-kit/core'
import {
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy
} from '@dnd-kit/sortable'

interface WrapperProps {
  onDragEnd?: (event: DragEndEvent) => void,
  onDragStart?: (event: DragStartEvent) => void,
  ids: (string | number)[],
  fixedRowCount?: number
}

export const Wrapper = ({ onDragEnd, onDragStart, ids, fixedRowCount = 0 }: WrapperProps) => {
  return function DraggableWrapper(props: React.HTMLAttributes<HTMLTableSectionElement>) {
    // Add sensors for better accessibility and user experience
    const sensors = useSensors(
      useSensor(PointerSensor, {
        activationConstraint: {
          distance: 8 // Require 8px of movement to start dragging
        }
      }),
      useSensor(KeyboardSensor, {
        coordinateGetter: sortableKeyboardCoordinates
      })
    )

    const draggableIds = ids.slice(fixedRowCount)

    return (
      <DndContext
        onDragEnd={onDragEnd}
        onDragStart={onDragStart}
        sensors={sensors}
        collisionDetection={closestCenter}
      >
        <SortableContext
          items={draggableIds}
          strategy={verticalListSortingStrategy}
        >
          <tbody {...props} />
        </SortableContext>
      </DndContext>
    )
  }
}
